<template>
  <div v-if="isUpdateAvailable">
    <div id="overlay" @click="closeOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
        <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
            <div class="flex flex-row mb-2 justify-between items-center">
                <div class="align-center text-lg text-left font-semibold py-2"> A new version is available!</div>
                <img @click="closeOverlay()" class="w-6 h-6 cursor-pointer" src="../../../assets/close.png">
            </div>
            <label class="text-grey-darker font-light text-xs">Please reload for better experience.</label>
            <div class="flex flex-row mt-3 mb-2 justify-start">
                <div v-on:click="reload" class="flex flex-col bg-blue font-semibold px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">
                  Reload
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isUpdateAvailable: false
    }
  },
  mounted () {
    /* Check for version updates */
    setInterval(() => {
      this.checkUpdates()
    }, 15 * 60 * 1000)
  },
  methods: {
    reload () {
      window.location.reload()
    },
    closeOverlay () {
      this.isUpdateAvailable = false
    },
    checkUpdates () {
      let vm = this
      let previousHtml = sessionStorage.getItem('previousHtml') ? sessionStorage.getItem('previousHtml') : null
      return fetch(window.location.protocol + '//' + window.location.host + '/index.html')
      .then(response => {
        if (response.status !== 200) {
          throw new Error('offline')
        }
        return response.text()
      })
      .then(html => {
        if (!previousHtml) {
          previousHtml = html
          sessionStorage.setItem('previousHtml', previousHtml)
          return false
        }
        if (previousHtml !== html) {
          previousHtml = html
          sessionStorage.setItem('previousHtml', previousHtml)
          console.log('Update Available')
          vm.isUpdateAvailable = true
          return true
        }
      })
      .catch(e => { console.log(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modals/NewUpdateAvailable.vue